import HeadingSecondary from "../components/ HeadingSecondary";
import appBg from "../assets/images/app-bg.png";
import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import Skeleton from "react-loading-skeleton";
import { useDispatch } from "react-redux";
import { ActionType } from "../store/action_type";
import QrReader from "react-qr-reader";
import AlertMessage from "../components/AlertMessage";
import { ToastContainer, toast } from "react-toastify";
import _ from "lodash";
import "react-toastify/dist/ReactToastify.css";
import GuildBottomSheet from "../components/GuildBottomSheet";
import { useActions } from "../hooks/useActions";
import { useSelector } from "../hooks/useTypedSelector";
import GuildListLog from "../components/GuildListLog";
import Filter from "../components/svg/Filter";
import BottomArrow from "../components/svg/BottomArrow";
import DotLoading from "../components/DotLoading";
import CONSTANTS from "../constants/constant.enum";
import qs from "qs";
import { isValidURL } from "../helper/helper";

export let activePermission = false;
const Guild: React.FC<any> = (props: any) => {
  const guildQrCodeParam = CONSTANTS.guildQrCodeParam;
  const [scanResultWebCam, setScanResultWebCam] = useState("");
  const [showContentOfInquiry, setShowContentOfInquiry] = useState(false);
  const [showQrReader, setShowQrReader] = useState(false);
  const [showAlertPrimary, setShowAlertPrimary] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const [showGuildBottomSheet, setShowGuildBottomSheet] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [confirmShowGuildBottomSheet, setConfirmShowGuildBottomSheet] =
    useState(false);
  const { fetchGuildSingle } = useActions();
  const dispatch = useDispatch();

  type GuildInquiryForm = {
    codeRef: string;
  };
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm<GuildInquiryForm>();

  const {
    data: singleGuildData,
    error: singleGuildError,
    loading: singleGuildLoading,
  } = useSelector((state) => state.guildSingleLog);
  const onSubmit = async (formData: GuildInquiryForm, e: any) => {
    fetchGuildSingle(formData.codeRef);
    setConfirmShowGuildBottomSheet(true);
    reset();
    // console.log(formData);
  };

  useEffect(() => {
    if (
      !singleGuildError &&
      !singleGuildLoading &&
      !_.isEmpty(singleGuildData) &&
      confirmShowGuildBottomSheet
    ) {
      setShowGuildBottomSheet(true);
    }
  }, [
    singleGuildError,
    singleGuildLoading,
    singleGuildData,
    confirmShowGuildBottomSheet,
  ]);

  useEffect(() => {
    if (singleGuildError) {
      setError("codeRef", {
        type: "server",
      });
    }
    // eslint-disable-next-line
  }, [singleGuildError]);

  useEffect(() => {
    if (scanResultWebCam !== "") {
      if (scanResultWebCam.includes(CONSTANTS.guildQrCodeParam)) {
        if (isValidURL(scanResultWebCam)) {
          let qrID = new URL(scanResultWebCam);
          if (qrID.searchParams.get(CONSTANTS.guildQrCodeParam)) {
            fetchGuildSingle(qrID.searchParams.get(CONSTANTS.guildQrCodeParam));
            setShowGuildBottomSheet(true);
          }
        }
      } else {
        return;
      }
      // alert(scanResultWebCam);
      // fetchGuildSingle(scanResultWebCam);
      // setShowGuildBottomSheet(true);
    }
    // eslint-disable-next-line
  }, [scanResultWebCam]);
  const handleScanWebCam = (result: any) => {
    if (result) {
      document
        .querySelector(".qr-reader > section > div")!
        .classList.add("green-qr");
      setScanResultWebCam(result);
      setShowQrReader(false);
    }
  };

  const handleErrorWebCam = (error: any) => {
    console.log(error);
  };

  const [successMessage, setSuccessMessage] = useState(null);

  useEffect(() => {
    if (successMessage !== null) {
      toast.success("نظر شما با موفقیت ثبت شد.", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
      });
    }
  }, [successMessage]);

  const handleShowQrReader = () => {
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions
        // @ts-ignore
        .query({ name: "camera" })
        .then(function (result) {
          // alert(result.state);
          if (result.state === "granted") {
            setShowQrReader(false);
            setShowQrReader(true);
            return false;
            //permission has already been granted, no prompt is shown
          } else if (result.state === "prompt") {
            setShowAlertPrimary(true);
            // if (window.confirm("نیاز به دسترسی دوربین")) {
            //   setShowQrReader(true);
            // }
            return false;
            //there's no peristent permission registered, will be showing the prompt
          } else if (result.state === "denied") {
            setShowAlertMessage(true);
            return false;
            // window.confirm(
            //   "برای خواندن تصویر کیوآٰرکد دسترسی به دوربین لازم است . لطفا از بخش تنظیمات دسترسی به دوربین را فعال کنید."
            // );
          }
        })
        .catch((e) => {
          setShowQrReader(true);
        });
    } else {
      setShowQrReader(true);
    }
  };

  const { data, loading } = useSelector((state) => state.guildListLog);

  const { fetchGuildList } = useActions();
  useEffect(() => {
    dispatch({
      type: ActionType.FETCH_GUILD_LIST,
    });
    let delayReq = setTimeout(() => {
      fetchGuildList();
    }, 1000);

    return () => {
      clearTimeout(delayReq);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (document.getElementById("alert-primary")) {
      let fixed = document.getElementById("alert-primary");

      fixed!.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault();
        },
        false
      );

      return fixed!.removeEventListener("touchmove", (e) => e.preventDefault());
    }
  }, []);

  const closeAlertPrimary = (e: any) => {
    if (alertPrimaryRef.current === e.target) {
      setShowAlertPrimary(false);
      return false;
    }
  };

  const handleActivePermission = (e: any, param: string) => {
    if (param === "ok") {
      setShowAlertPrimary(false);
      setShowQrReader(true);
      return true;
    }
    setShowAlertPrimary(false);
    return false;
  };

  useEffect(() => {
    // console.log(showContentOfInquiry);
    let timer = setTimeout(() => {
      setShowContentOfInquiry(true);
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [showContentOfInquiry]);

  const alertPrimaryRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const queryStringParsed = qs.parse(props.location.search.slice(1));
    // console.log(queryStringParsed);
    if (queryStringParsed[guildQrCodeParam]) {
      fetchGuildSingle(queryStringParsed[guildQrCodeParam]);
      setShowGuildBottomSheet(true);
    } else {
      return;
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <ToastContainer rtl />
      <div
        className="alert-primary"
        id="alert-primary"
        onClick={closeAlertPrimary}
        ref={alertPrimaryRef}
        style={{ maxHeight: `${showAlertPrimary ? "100%" : "0%"}` }}
      >
        <div
          className="alert-primary__permission"
          style={{ maxHeight: `${showAlertPrimary ? "100%" : "0%"}` }}
        >
          <h6>دسترسی به دوربین</h6>
          <p>
            برای خواندن QR کد نیاز به دسترسی دوربین میباشد.بعد از گزینه فعال
            کردن دکمه allow را بزنید.
          </p>
          <div className="alert-primary__btn-gp">
            <button
              className="btn btn--anchor u-width-49 u-d-flex u-justify-content-center u-align-item-center"
              onClick={(event) => handleActivePermission(event, "nok")}
            >
              الان نه
            </button>
            <button
              className="btn btn--primary small u-width-49"
              onClick={(event) => handleActivePermission(event, "ok")}
            >
              فعال کردن
            </button>
          </div>
        </div>
      </div>

      <AlertMessage
        title="دسترسی به دوربین"
        body="در بخش تنظیمات یا مرورگر خود دسترسی به دوربین را فعال کنید."
        btn="متوجه شدم"
        onShowAlertMessage={showAlertMessage}
        onSetShowAlertMessage={setShowAlertMessage}
      />

      {showGuildBottomSheet ? (
        <GuildBottomSheet
          onShowGuildBottomSheet={showGuildBottomSheet}
          onSetShowGuildBottomSheet={setShowGuildBottomSheet}
          setScanResultWebCam={setScanResultWebCam}
          setSuccessMessage={setSuccessMessage}
          successMessage={successMessage}
        />
      ) : null}

      <div className="guild">
        <div className="u-margin-top-small-3 u-margin-bottom-small-2">
          <HeadingSecondary text="اصناف" />
        </div>

        <div className="guild__inquiry u-margin-bottom-small-3 u-width-100">
          <p className="guild__inquiry__title">استعلام واحد صنفی</p>
          <p className="guild__inquiry__text">
            دوربین تلفن همراه خود را به سمت QR کد واحد صنفی مورد نظر بگیرید.
          </p>
          {showQrReader ? (
            <QrReader
              className="qr-reader"
              delay={300}
              style={{ width: "100%" }}
              onError={handleErrorWebCam}
              onScan={handleScanWebCam}
            />
          ) : (
            <img src={appBg} alt="app bg" />
          )}
          {/*<p>{scanResultWebCam}</p>*/}
          <div className="u-width-100 u-margin-center-auto u-margin-top-small-2">
            <button
              className="btn btn--primary medium"
              onClick={handleShowQrReader}
            >
              <span>اسکن QR کد</span>
            </button>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                className={`guild__inquiry__input-container ${
                  errors.codeRef ? "input-error" : ""
                }`}
              >
                <input
                  type="text"
                  className="guild__inquiry__input-container--element"
                  placeholder="ورود شناسه QR کد"
                  {...register("codeRef", {
                    required: true,
                    minLength: {
                      value: 5,
                      message: "Too Many Characters",
                    },
                  })}
                />
                <button
                  className="btn btn--primary guild__inquiry__input-container--btn"
                  type={`${singleGuildLoading ? "button" : "submit"}`}
                >
                  {singleGuildLoading ? <DotLoading /> : "استعلام"}
                </button>
              </div>
              <div className="error-box u-margin-top-small-1 u-text-right">
                {errors.codeRef && errors.codeRef.type === "required" && (
                  <p className="error-box__content u-text-right u-rtl">
                    پر کردن این فیلد الزامی است .
                  </p>
                )}

                {errors.codeRef && errors.codeRef.type === "server" && (
                  <p className="error-box__content u-text-right">
                    {singleGuildError}
                  </p>
                )}
                {errors.codeRef && errors.codeRef.type === "minLength" && (
                  <p className="error-box__content u-text-right u-rtl">
                    تعداد حروف کوتاه است.
                  </p>
                )}
                {/* {singleGuildError && <p className="error-box__content">{singleGuildError}</p>} */}
                {/* <p className="error-box__content u-text-right u-ltr">
                  . شناسه وارد شده صحیح نیست، مجددا تلاش بفرمایید
                </p> */}
              </div>
            </form>
          </div>
        </div>

        <div className="guild__inquiry-records  u-margin-bottom-big-7 u-width-100">
          <p className="guild__inquiry__title">سوابق استعلام ها</p>
          {loading && <Skeleton count={7} />}
          {!showContentOfInquiry ? null : loading ? null : data.length <
            2 ? null : (
            <div className="guild__inquiry__filter">
              <div
                className="guild__inquiry__filter__logo"
                onClick={() => {
                  setCollapsed(!collapsed);
                }}
              >
                <Filter />
                <BottomArrow collapsed={collapsed} />
              </div>

              <div className="guild__inquiry__filter__content-holder">
                <div
                  className="guild__inquiry__filter__content-holder__content"
                  style={{
                    height: `${!collapsed ? "132px" : "0"}`,
                    opacity: `${!collapsed ? "1" : "0"}`,
                  }}
                >
                  <h6>مرتب سازی بر اساس</h6>
                  <div className="line2"></div>
                  <ul>
                    <li>
                      <input
                        type="radio"
                        name="order"
                        value="DESC"
                        id="new"
                        onChange={(e) => {
                          fetchGuildList(e.target.value);
                          setCollapsed(!collapsed);
                        }}
                      />
                      <label htmlFor="new">جدیدترین</label>
                    </li>
                    <div className="line2"></div>
                    <li>
                      <input
                        type="radio"
                        name="order"
                        value="ASC"
                        id="old"
                        onChange={(e) => {
                          fetchGuildList(e.target.value);
                          setCollapsed(!collapsed);
                        }}
                      />
                      <label htmlFor="old">قدیمی ترین</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          {!showContentOfInquiry ? null : loading ? null : data.length === 0 ? (
            <div className="guild-none-record-box">
              <p className="guild-none-record-box__title">
                استعلامی صورت نگرفته
              </p>
              <p className="guild-none-record-box__line"></p>
              <div className="guild-none-record-box__possibilities">
                <span>امکانات سامانه:</span>
                <ul>
                  <li>
                    <span> </span>
                    <p>استعلام وضعیت فعالیت هر واحد صنفی</p>
                  </li>
                  <li>
                    <span> </span>
                    <p>استعلام وضعیت سلامت افراد شاغل در هر واحد صنفی</p>
                  </li>
                  <li>
                    <span> </span>
                    <p>مشاهده دستور العمل های مربوط به هر واحد صنفی</p>
                  </li>
                  <li>
                    <span> </span>
                    <p>مشاهده اطلاعات واحد صنفی</p>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <GuildListLog
              setShowGuildBottomSheet={setShowGuildBottomSheet}
              guildData={data}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Guild;
